import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';
import TicketButton from '../../Buttons/TicketButton/TicketButton';
import {
  TicketTextRegular,
  NewMessageTextAreaHolder,
  smallScreens,
  mediumScreens,
  lowHeightScreens,
} from '../../common/fontElements';
import { DraftHelpers } from '../../../util/Draft';

export const ErrorMessage = styled.p`
  color: ${colors.red2};
  font-size: 14px;
`;

export const Icon = styled.img`
  width: 15px;
  cursor: pointer;

  @media screen and (max-width: ${mediumScreens}) {
    width: 12px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    width: 10px;
  }
`;

export const MessageBox = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 1;
  background-color: ${colors.baseBackground};
  padding: 0 0 10px 0;
  flex-wrap: nowrap;
  height: 100%;
  width: 100%;
  overflow-y: auto;
`;

export const EmojiContainer = styled.div`
  flex-direction: column;
  display: flex;

  /* emoji styles */

  .emoji-mart {
    font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    font-size: 16px;
    display: inline-block;
    color: ${colors.baseText};
    border: 1px solid ${colors.dividerColor};
    border-radius: 5px;
    background: ${colors.baseBackground};
    & * {
      box-sizing: border-box;
      line-height: 1.15;
    }
    & .emoji-mart-emoji {
      padding: 6px;
    }
  }

  .emoji-mart .emoji-mart-emoji {
    padding: 6px;
  }

  .emoji-mart-bar {
    border: 0 solid ${colors.dividerColor};
    &:first-child {
      border-bottom-width: 1px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
    &:last-child {
      border-top-width: 1px;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }

  .emoji-mart-anchors {
    display: flex;
    justify-content: space-between;
    padding: 0 6px;
    color: ${colors.tabsTextColor};
    line-height: 0;
    & i {
      display: inline-block;
      width: 100%;
      max-width: 22px;
    }
    & svg {
      fill: currentColor;
      max-height: 18px;
    }
  }

  .emoji-mart-anchor {
    position: relative;
    flex: 1;
    text-align: center;
    padding: 12px 4px;
    overflow: hidden;
    transition: color 0.1s ease-out;
  }
  .emoji-mart-anchor:hover,
  .emoji-mart-anchor-selected {
    color: ${colors.lightGray34};
  }

  .emoji-mart-anchor-selected .emoji-mart-anchor-bar {
    bottom: 0;
  }

  .emoji-mart-anchor-bar {
    position: absolute;
    bottom: -3px;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: ${colors.lightGray34};
  }

  .emoji-mart-scroll {
    overflow-y: scroll;
    height: 270px;
    padding: 0 6px 6px 6px;
  }

  .emoji-mart-search {
    margin-top: 6px;
    padding: 0 6px;
    & input {
      font-size: 16px;
      display: block;
      width: 100%;
      padding: 0.2em 0.6em;
      border-radius: 25px;
      border: 1px solid ${colors.dividerColor};
      outline: 0;
    }
  }

  .emoji-mart-category .emoji-mart-emoji span {
    z-index: 1;
    position: relative;
    text-align: center;
    cursor: default;
  }

  .emoji-mart-category .emoji-mart-emoji:hover:before {
    z-index: 0;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${colors.lightGray10};
    border-radius: 100%;
  }

  .emoji-mart-category-label {
    z-index: 2;
    position: relative;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  }

  .emoji-mart-category-label span {
    display: block;
    width: 100%;
    font-weight: 500;
    padding: 5px 6px;
    background-color: ${colors.baseBackground};
  }

  .emoji-mart-emoji {
    position: relative;
    display: inline-block;
    font-size: 0;
  }

  .emoji-mart-no-results {
    font-size: 14px;
    text-align: center;
    padding-top: 70px;
    color: ${colors.tabsTextColor};

    .emoji-mart-category-label {
      display: none;
    }

    .emoji-mart-no-results-label {
      margin-top: 0.2em;
    }

    .emoji-mart-emoji:hover:before {
      content: none;
    }
  }

  .emoji-mart-preview {
    position: relative;
    height: 60px;
  }

  .emoji-mart-preview-emoji,
  .emoji-mart-preview-data,
  .emoji-mart-preview-skins {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .emoji-mart-preview-emoji {
    left: 12px;
  }

  .emoji-mart-preview-data {
    left: 68px;
    right: 12px;
    word-break: break-all;
  }

  .emoji-mart-preview-skins {
    right: 30px;
    text-align: right;
  }

  .emoji-mart-preview-name {
    font-size: 14px;
  }

  .emoji-mart-preview-shortname {
    font-size: 12px;
    color: ${colors.darkGray};
  }
  .emoji-mart-preview-shortname + .emoji-mart-preview-shortname,
  .emoji-mart-preview-shortname + .emoji-mart-preview-emoticon,
  .emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon {
    margin-left: 0.5em;
  }

  .emoji-mart-preview-emoticon {
    font-size: 11px;
    color: ${colors.lightGray19};
  }

  .emoji-mart-title span {
    display: inline-block;
    vertical-align: middle;
  }

  .emoji-mart-title .emoji-mart-emoji {
    padding: 0;
  }

  .emoji-mart-title-label {
    color: ${colors.lightGray9};
    font-size: 26px;
    font-weight: 300;
  }

  .emoji-mart-skin-swatches {
    font-size: 0;
    padding: 2px 0;
    border: 1px solid ${colors.dividerColor};
    border-radius: 12px;
    background-color: ${colors.baseBackground};
  }

  .emoji-mart-skin-swatches-opened .emoji-mart-skin-swatch {
    width: 16px;
    padding: 0 2px;
  }

  .emoji-mart-skin-swatches-opened .emoji-mart-skin-swatch-selected:after {
    opacity: 0.75;
  }

  .emoji-mart-skin-swatch {
    display: inline-block;
    width: 0;
    vertical-align: middle;
    transition-property: width, padding;
    transition-duration: 0.125s;
    transition-timing-function: ease-out;
  }

  .emoji-mart-skin-swatch:nth-child(1) {
    transition-delay: 0s;
  }
  .emoji-mart-skin-swatch:nth-child(2) {
    transition-delay: 0.03s;
  }
  .emoji-mart-skin-swatch:nth-child(3) {
    transition-delay: 0.06s;
  }
  .emoji-mart-skin-swatch:nth-child(4) {
    transition-delay: 0.09s;
  }
  .emoji-mart-skin-swatch:nth-child(5) {
    transition-delay: 0.12s;
  }
  .emoji-mart-skin-swatch:nth-child(6) {
    transition-delay: 0.15s;
  }

  .emoji-mart-skin-swatch-selected {
    position: relative;
    width: 16px;
    padding: 0 2px;
  }
  .emoji-mart-skin-swatch-selected:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 4px;
    height: 4px;
    margin: -2px 0 0 -2px;
    background-color: #fff;
    border-radius: 100%;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.2s ease-out;
  }

  .emoji-mart-skin {
    display: inline-block;
    width: 100%;
    padding-top: 100%;
    max-width: 12px;
    border-radius: 100%;
  }

  .emoji-mart-skin-tone-1 {
    background-color: #ffc93a;
  }
  .emoji-mart-skin-tone-2 {
    background-color: #fadcbc;
  }
  .emoji-mart-skin-tone-3 {
    background-color: #e0bb95;
  }
  .emoji-mart-skin-tone-4 {
    background-color: #bf8f68;
  }
  .emoji-mart-skin-tone-5 {
    background-color: #9b643d;
  }
  .emoji-mart-skin-tone-6 {
    background-color: #594539;
  }
`;

export const Wrapper = styled.div`
  height: 100%;
  min-height: 80px;
`;

export const BottomNotice = styled.div`
  display: inline-block;
  font-size: 12px;
  color: ${colors.copyButtonText};
  font-family: 'Lato', sans-serif;
  margin: 2px 20px;
`;

export const BusinessReminder = styled.span`
  display: flex;
  font-family: lato, sans-serif;
  font-size: 1.1rem;
  font-weight: 400;
  line-height: 1.3rem;
  color: ${colors.lightGray34};
  white-space: normal;

  & span {
    text-decoration: underline;
    font-family: 'Lato-Bold', sans-serif;
  }
`;

export const MessageForm = styled.form`
  z-index: 1;
  padding: 12px 0px 10px;
  flex: 1 1;
  min-height: 50px;
  min-height: 100px;
  margin: 0px 16px;
  background-color: inherit;
`;

export const BottomSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  height: 30px;
  margin: 0px 16px;
`;

export const FlexFill = styled.div`
  flex: 1 1;
`;

export const Emoji = styled.div`
  display: flex;
`;

export const EmojiIcon = styled(Icon)`
  flex: 1;
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  padding-right: 5px;
  margin: 5px 0;
  opacity: ${(props) => (props.commerceWizardActive ? 0.3 : 1)};
`;

export const TextareaHolder = styled.div`
  width: 100%;
  height: 100%;
  min-height: 80px;
`;

export const TextareaBoxOuter = styled(NewMessageTextAreaHolder)`
  background-color: ${colors.baseBackground};
  display: flex;
  flex: 1;
  justify-content: space-around;
  border-radius: 7.2px;
  border: 1px solid ${(props) => (props.haveError ? colors.popupRedText : colors.lightGray24)};
  transition: border 0.5s;
  height: 100%;
  color: ${colors.gulfBlue};

  &:focus-within {
    border-color: ${(props) => (props.haveError ? colors.popupRedText : colors.blue1)};
  }

  &[disabled] {
    pointer-events: none;
    background-color: ${colors.lightGray14};
    border-color: ${colors.lightGray21};
    color: ${colors.darkGray1};

    & ${IconContainer} {
      opacity: 0.5;
    }
  }

  & > grammarly-editor-plugin {
    flex: 1;
  }

  .msg-editor-wrapper {
    height: calc(100% - 14px);
    border: 0;
    flex: 1;
    overflow: hidden;
    outline: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 7px;
    ::placeholder {
      color: ${colors.lightGray8};
    }

    .msg-editor {
      border: 0;
      margin-bottom: 0;
      overflow: auto;

      &.rdw-editor-main {
        min-height: 100%;
        padding: 0px;

        .public-DraftStyleDefault-block {
          margin-top: ${DraftHelpers.marginTop};
          margin-bottom: ${DraftHelpers.marginBottom};
        }

        .public-DraftStyleDefault-block:first-of-type {
          margin-top: 0;
        }

        img {
          margin-top: ${DraftHelpers.marginTop};
          margin-bottom: ${DraftHelpers.marginBottom};
        }
      }

      .rdw-image-alignment-options-popup {
        display: none;
      }

      .rdw-image-center {
        justify-content: flex-start;
      }

      .rdw-image-imagewrapper img {
        max-width: 100%;
      }
    }
  }
`;

export const ExpandIcon = styled(Icon)`
  margin-bottom: 2px;
`;

export const SendButton = styled(TicketButton)`
  margin: 0px;
`;

export const BottomNoticeText = styled(TicketTextRegular)`
  opacity: ${(props) => (props.commerceWizardActive ? 0.4 : 1)};
`;
